var Dictionary = /** @class */ (function () {
    function Dictionary(key, value) {
        this.key = key;
        this.value = value;
    }
    return Dictionary;
}());
export { Dictionary };
//# sourceMappingURL=dictionary.js.map